<template>
  <div id="assetssearch-maindiv" class="page-maindiv">
    <!-- Main -->
    <div class="area-main">
      <!-- Area titolo -->
      <div class="area-top">
        <div class="area-top-title">
          {{ $t('menu.ricerca') }}
        </div>
        <div class="area-description mt-0 font-italic">
          {{ filteredAssets.length + " " + $tc('risultati-n', filteredAssets.length) }}
        </div>
      </div>
      <div class="area-description" v-html="pageDescription"></div>
      <!-- Area ricerca -->
      <div class="assetsearch-main-div">
        <div class="assetsearch-main-div-left">
          <div class="mt-2 mb-2 flex-column asset-description-text">
            <div class="assetsearch-filter-title mb-0">
              {{ $t("filtro_semplice") }}
            </div>
            <div class="assetsearch-filter-subtitle">
              {{ $t("filtro_semplice_didascalia") }}
            </div>
            <b-input-group>
              <b-input-group-prepend style="height: 40px" is-text>
                <b-icon icon="search"></b-icon>
              </b-input-group-prepend>
              <b-form-input v-model="searchFilter.freeSearch" style="height: 40px" type="search" @input="refresh()"></b-form-input>
            </b-input-group>
          </div>

          <div class="asset-description-text mt-5">
            <div class="assetsearch-filter-title">
              {{ $t("filtro_data") }}
            </div>
            <div style="display: flex; flex-direction: row; align-items: baseline">
              <div class="assetsearch-filter-subtitle">
                {{ $t("data_da") }}
              </div>
              <div style="margin-left: 10px">
                <b-form-input v-model="searchFilter.yearStart" :placeholder="$t('data_da')" type="number" @input="refresh()"></b-form-input>
              </div>
              <div class="assetsearch-filter-subtitle ml-3">
                {{ $t("data_a") }}
              </div>
              <div style="margin-left: 10px">
                <b-form-input v-model="searchFilter.yearEnd" :placeholder="$t('data_a')" type="number" @input="refresh()"></b-form-input>
              </div>
            </div>
          </div>

          <div class="asset-description-text mt-5">
            <div class="assetsearch-filter-title">
              {{ $t("filtro_luogo") }}
            </div>
            <b-table style="font-size: small" sticky-header selectable select-mode="single" striped small hover @row-selected="onPlaceRowSelected"
                     :items="this.arrPlacesTableItems" :fields="arrPlacesFields" :sort-by="$t('catalogo_luogo')" selected-variant="primary" ref="tablePlaces">
                <template #head()="data">
                  <span style="font-size: medium">{{ data.label }}</span>
                </template>
            </b-table>
          </div>

          <div class="asset-description-text mt-5">
            <div class="assetsearch-filter-title mb-0">
              {{ $t("filtro_nome") }}
            </div>
            <div class="assetsearch-filter-subtitle">
              {{ $t("filtro_nome_didascalia") }}
            </div>
            <b-table style="font-size: small" sticky-header selectable select-mode="single" striped small hover @row-selected="onAuthorRowSelected"
                     :items="this.arrAuthorsTableItems" :fields="arrAuthorFields" :sort-by="$t('nome')" selected-variant="primary" ref="tableAuthors">
              <template #head()="data">
                <span style="font-size: medium">{{ data.label }}</span>
              </template>
            </b-table>
          </div>

          <div class="asset-description-text mt-5">
            <div class="assetsearch-filter-title">
              {{ $t("filtro_materia") }}
            </div>
            <b-table style="font-size: small" sticky-header selectable select-mode="single" striped small hover @row-selected="onMaterialRowSelected"
                     :items="this.arrMaterialsTableItems" :fields="arrMaterialsFields" :sort-by="$t('catalogo_materia')" selected-variant="primary" ref="tableMaterials">
              <template #head()="data">
                <span style="font-size: medium">{{ data.label }}</span>
              </template>
            </b-table>
          </div>

        </div>
        <div class="assetsearch-main-div-right">
          <div class="spinner-div"><b-spinner class="spinner" label="Busy" v-if="loading"></b-spinner></div>
          <!-- Area cards -->
          <div class="assets-cards" ref="cardsref" v-if="!loading">
            <b-card
                class="assets-card"
                no-body
                border-variant="white"
                v-for="(asset, index) in shownAssets"
                :key="asset.preview"
            >
              <div @mouseover="hoverCard(index)" @mouseout="hoverCard(-1)">
                <b-link :to="{ name: 'asset', params: {idAsset: asset.id, previousPageLink: '/assetssearch', previousPageTitle: $t('menu.ricerca')}}"
                        style="text-decoration: none;color: #2c3e50;width: 100%">
                  <b-card-img class="assets-card-image" :class="{'selected': isCardSelected(index)}" :src="asset.image" :alt="$utilities.getTranslation(asset, 'nome', $i18n.locale)" top v-if="asset.image != null"></b-card-img>
                </b-link>
              </div>
              <b-link :to="{ name: 'asset', params: {idAsset: asset.id, previousPageLink: '/assetssearch', previousPageTitle: $t('menu.ricerca')}}"
                      style="text-decoration: none;color: #2c3e50" @mouseover="hoverCard(index)" @mouseout="hoverCard(-1)">
                <b-card-text class="results-card-title" style="margin-left: 10px; margin-top: 5px; margin-bottom: 0">
                  {{ $utilities.getTranslation(asset, "nome", $i18n.locale) }}
                </b-card-text>
                <b-card-text class="results-card-subtitle" style="margin-left: 10px;margin-right: 10px">
                  {{ $utilities.getTranslation(asset, "nome2", $i18n.locale) }}
                </b-card-text>
              </b-link>
              <b-link v-show="getCollectionName(asset.collezione) != null"
                      :to="{name: 'assets', params: {idCollection: asset.collezione, previousPageLink: '/assetssearch', previousPageTitle: $t('menu.ricerca')}}"
                      style="text-decoration: none;color: #2c3e50" @mouseover="hoverCollection(index)" @mouseout="hoverCollection(-1)">
                <b-card-text class="results-card-subtitle" style="margin-left: 10px;margin-right: 10px" :class="{'selected': isCollectionSelected(index)}" >
                  {{ getCollectionName(asset.collezione) }}
                </b-card-text>
              </b-link>
              <div class="mt-2">
                <b-card-text class="card-other-data" style="margin-left: 10px;margin-right: 10px" v-html="getAssetYears(asset)" v-if="getAssetYears(asset) != null"></b-card-text>
                <b-card-text class="card-other-data" style="margin-left: 10px;margin-right: 10px" v-html="getAssetPlace(asset)" v-if="getAssetPlace(asset) != null"></b-card-text>
                <b-card-text class="card-other-data" style="margin-left: 10px;margin-right: 10px" v-html="getAssetMaterial(asset)" v-if="getAssetMaterial(asset) != null"></b-card-text>
                <b-card-text class="card-other-data" style="margin-left: 10px;margin-right: 10px" v-html="getAssetAuthor(asset)" v-if="getAssetAuthor(asset) != null"></b-card-text>
                <b-card-text class="card-other-data" style="margin-left: 10px;margin-right: 10px" v-html="getAssetBuilder(asset)" v-if="getAssetBuilder(asset) != null"></b-card-text>
              </div>
            </b-card>
          </div>
          <div style="display: flex; flex-direction: row; height: 53px; margin: 50px;" v-if="filteredAssets.length > nLoadedAssets">
            <div style="width: 45%; height: 53px; margin: 25px 0 0 0;">
              <hr style="border-top: 2px solid #DCAC00;margin: 0"/>
            </div>
            <div
                style="width: 288px; height: 53px;flex-direction: column; justify-content: center; border-radius: 26px;border: 2px solid #DCAC00;cursor:pointer;">
              <div
                  style="font-family: 'Montserrat';font-style: normal;font-weight: 500;font-size: 16px;line-height: 20px;letter-spacing: 0.1em;color: #DCAC00;text-align: center;vertical-align: middle;line-height: 50px;" @click="nLoadedAssets += 10; refresh();">
                {{ $t('carica_altri') }}
              </div>
            </div>
            <div style="width: 45%; height: 53px; margin: 25px 0 0 0;">
              <hr style="border-top: 2px solid #DCAC00;margin: 0"/>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AssetsSearch',
  data: function() {
    return {
      pageDescriptionRecord: "",
      structures: null,
      collections: null,
      assets: [],
      nLoadedAssets: 20,
      loading: true,
      selectedCollection: -1, // Collezione selezionata (hover sulla collezione, per filtro al clic)
      searchFilter: {
        freeSearch: '', // Stringa di ricerca
        place: '',
        author: '',
        material: '',
        yearStart: '',
        yearEnd: '',
      },
      arrPlaces: [],
      arrPlacesFields: [
        {
          key: this.$t("catalogo_luogo"),
          sortable: true
        },
        {
          key: "# " + this.$t("beni"),
          sortable: true
        }
      ],
      arrAuthors: [],
      arrAuthorFields: [
        {
          key: this.$t("nome"),
          sortable: true
        },
        {
          key: "# " + this.$t("beni"),
          sortable: true
        }
      ],
      arrMaterials: [],
      arrMaterialsFields: [
        {
          key: this.$t("catalogo_materia"),
          sortable: true
        },
        {
          key: "# " + this.$t("beni"),
          sortable: true
        }
      ],
      shownAssets: null,
    };
  },
  created() {
    this.fetchAssets();
  },
  computed: {
    pageDescription() {
      let desc = "";
      if (this.pageDescriptionRecord != null)
        for (let trad in this.pageDescriptionRecord["traduzioni"]) {
          if (this.pageDescriptionRecord["traduzioni"][trad]["lingua"].startsWith("it"))
            desc = this.pageDescriptionRecord["traduzioni"][trad].contenuto;
          if (this.pageDescriptionRecord["traduzioni"][trad]["lingua"].startsWith(this.$i18n.locale))
            desc = this.pageDescriptionRecord["traduzioni"][trad].contenuto;
        }
      return desc;
    },
    filteredAssets() {
      let assets = this.assets;
      // Filtro per data
      if (this.searchFilter.yearStart !== '') {
        assets = assets.filter(asset => asset.anno_inizio != null && asset.anno_inizio >= parseInt(this.searchFilter.yearStart));
      }
      if (this.searchFilter.yearEnd !== '') {
        assets = assets.filter(asset => asset.anno_fine != null && asset.anno_fine <= parseInt(this.searchFilter.yearEnd));
      }
      // Filtro per nome/descrizione
      if (this.searchFilter.freeSearch !== '') {
        assets = assets.filter(asset => {
          let name = this.$utilities.getTranslation(asset, "nome", this.$i18n.locale);
          let description = this.$utilities.getTranslation(asset, "descrizione", this.$i18n.locale);
          name = name == null ? "" : name;
          description = description == null ? "" : description;
          return name.toLowerCase().includes(this.searchFilter.freeSearch.toLowerCase())
              || description.toLowerCase().includes(this.searchFilter.freeSearch.toLowerCase());
        });
      }
      // Filtro per luogo
      if (this.searchFilter.place !== '') {
        assets = assets.filter(asset => {
          let returnValue = false;
          let place = this.$utilities.getTranslation(asset, "catalogo_luogo", this.$i18n.locale);
          if (place != null && place !== "") {
            place = place.replace("<br />", " - ");
            const el = document.createElement('html');
            el.innerHTML = place;
            place = el.innerText;
            returnValue = place == this.searchFilter.place;
          }
          return returnValue;
        });
      }
      // Filtro per nome
      if (this.searchFilter.author !== '') {
        assets = assets.filter(asset => {
          let returnValue = false;
          let author = this.$utilities.getTranslation(asset, "catalogo_autore", this.$i18n.locale);
          if (author != null && author !== "") {
            const el = document.createElement('html');
            el.innerHTML = author;
            author = el.innerText;
            returnValue = author.indexOf(this.searchFilter.author) > -1;
          }
          let builder = this.$utilities.getTranslation(asset, "catalogo_costruttore", this.$i18n.locale);
          if (!returnValue && builder != null && builder !== "") {
            const el = document.createElement('html');
            el.innerHTML = builder;
            builder = el.innerText;
            returnValue = builder.indexOf(this.searchFilter.author) > -1;
          }
          return returnValue;
        });
      }
      // Filtro per materia
      if (this.searchFilter.material !== '') {
        assets = assets.filter(asset => {
          let returnValue = false;
          let materials = this.$utilities.getTranslation(asset, "catalogo_materia", this.$i18n.locale);
          if (materials != null && materials !== "") {
            materials = materials.split(",");
            for (let i in materials) {
              if (returnValue)
                break;
              let material = materials[i];
              const el = document.createElement('html');
              el.innerHTML = material.toLowerCase();
              material = el.innerText;
              returnValue = material == this.searchFilter.material;
            }
          }
          return returnValue;
        });
      }
      assets = assets.sort((a, b) => parseInt(a.order) - parseInt(b.order));
      let cardsref = this.$refs.cardsref;
      if (cardsref)
        cardsref.scrollIntoView({ behavior: "smooth" });
      return assets;
    },
    arrPlacesTableItems() {
      let arr = [];
      for (let i in this.arrPlaces) {
        let obj = {};
        obj[this.$t("catalogo_luogo")] = this.arrPlaces[i][0];
        obj["# " + this.$t("beni")] = this.arrPlaces[i][1];
        arr.push(obj);
      }
      return arr;
    },
    arrAuthorsTableItems() {
      let arr = [];
      for (let i in this.arrAuthors) {
        let obj = {};
        obj[this.$t("nome")] = this.arrAuthors[i][0];
        obj["# " + this.$t("beni")] = this.arrAuthors[i][1];
        arr.push(obj);
      }
      return arr;
    },
    arrMaterialsTableItems() {
      let arr = [];
      for (let i in this.arrMaterials) {
        let obj = {};
        obj[this.$t("catalogo_materia")] = this.arrMaterials[i][0];
        obj["# " + this.$t("beni")] = this.arrMaterials[i][1];
        arr.push(obj);
      }
      return arr;
    },
  },
  methods: {
    refresh() {
      this.loading = true;
      this.fetchImages(this.filteredAssets.slice(0, this.nLoadedAssets));
    },
    async fetchAssets() {
      // Descrizione pagina
      const pageDescriptionData = await this.$client.getItems("pagine", {
        fields: ["*", "traduzioni.*"],
        filter: {
          nome: {
            eq: 'ricerca'
          }
        }
      });
      if (pageDescriptionData.data !== null && pageDescriptionData.data.length > 0)
        this.pageDescriptionRecord = pageDescriptionData.data[0];

      // Collezione
      const collectionsData = await this.$client.getItems("collezioni", {fields: ["id", "id_dipartimento", "traduzioni.*"]});
      const collections = collectionsData.data;

      const assetsData = await this.$client.getItems("beni", {
        fields: ["id", "id_collezione", "traduzioni.*", "date.*"], limit: -1
      });
      let assets = assetsData.data;

      for (let collection in collections) {
        for (let asset in assets) {
          // Valorizza campo che punta alla collezione relativa
          if (assets[asset].id_collezione != null && collections[collection].id === assets[asset].id_collezione.id) {
            assets[asset].collezione = parseInt(collections[collection].id);
          }
        }
      }
      this.collections = collections;

      let mapPlaces = new Map();
      let mapAuthors = new Map();
      let mapMaterials = new Map();
      for (let assetIndex in assets) {
        const asset = assets[assetIndex];

        // Date
        if (asset.date != null && asset.date.length > 0) {
          let inizio = asset.date[0].data_inizio;
          let fine = asset.date[0].data_fine;
          if (inizio == null || inizio.length < 4)
            inizio = asset.date[0].anno_da;
          else
            inizio = inizio.substring(0, 4);
          if (fine == null || fine.length < 4)
            fine = asset.date[0].anno_a;
          else
            fine = fine.substring(0, 4);
          if (!this.$utilities.isEmpty(inizio))
            asset.anno_inizio = parseInt(inizio);
          if (!this.$utilities.isEmpty(fine))
            asset.anno_fine = parseInt(fine);
        }
        // Luoghi
        let place = this.$utilities.getTranslation(asset, "catalogo_luogo", this.$i18n.locale);
        if (place != null && place !== "") {
          place = place.replace("<br />", " - ");
          const el = document.createElement( 'html' );
          el.innerHTML = place;
          place = el.innerText;
          if (mapPlaces.has(place))
            mapPlaces.set(place, mapPlaces.get(place) + 1);
          else
            mapPlaces.set(place, 1);
        }
        // Autori
        let author = this.$utilities.getTranslation(asset, "catalogo_autore", this.$i18n.locale);
        if (author != null && author !== "") {
          let authors = author.split("<br />");
          for (let i in authors) {
            const el = document.createElement('html');
            el.innerHTML = authors[i];
            author = el.innerText;
            if (mapAuthors.has(author))
              mapAuthors.set(author, mapAuthors.get(author) + 1);
            else
              mapAuthors.set(author, 1);
          }
        }
        // Costruttori
        let builder = this.$utilities.getTranslation(asset, "catalogo_costruttore", this.$i18n.locale);
        if (builder != null && builder !== "") {
          let builders = builder.split("<br />");
          for (let i in builders) {
            const el = document.createElement('html');
            el.innerHTML = builders[i];
            builder = el.innerText;
            if (mapAuthors.has(builder))
              mapAuthors.set(builder, mapAuthors.get(builder) + 1);
            else
              mapAuthors.set(builder, 1);
          }
        }
        // Materie
        let materials = this.$utilities.getTranslation(asset, "catalogo_materia", this.$i18n.locale);
        if (materials != null && materials !== "") {
          materials = materials.split(",");
          for (let i in materials) {
            let material = materials[i];
            const el = document.createElement('html');
            el.innerHTML = material;
            material = el.innerText.toLowerCase();
            if (mapMaterials.has(material))
              mapMaterials.set(material, mapMaterials.get(material) + 1);
            else
              mapMaterials.set(material, 1);
          }
        }
      }
      let arrPlaces = [];
      mapPlaces.forEach(function(value, key) {
        arrPlaces.push([key, value]);
      })
      this.arrPlaces = arrPlaces;
      let arrAuthors = [];
      mapAuthors.forEach(function(value, key) {
        arrAuthors.push([key, value]);
      })
      this.arrAuthors = arrAuthors;
      let arrMaterials = [];
      mapMaterials.forEach(function(value, key) {
        arrMaterials.push([key, value]);
      })
      this.arrMaterials = arrMaterials;

      this.assets = assets.sort((a, b) => {
        const nomeA = this.$utilities.getTranslation(a, "nome", this.$i18n.locale);
        const nomeB = this.$utilities.getTranslation(b, "nome", this.$i18n.locale);
        if (nomeA.toLowerCase() > nomeB.toLowerCase()) {
          return 1;
        } else if (nomeA.toLowerCase() < nomeB.toLowerCase()) {
          return -1;
        } else
          return 0;
      });
      this.loading = "";
      await this.fetchImages(this.filteredAssets.slice(0, this.nLoadedAssets));
    },
    async fetchImages(assets) {
      let listOfAssetIds = "";
      for (let asset in assets) {
        listOfAssetIds += assets[asset].id + ",";
      }

      const joinsData = await this.$client.getItems("join_beni_directus_files", {fields: ["*"], limit: -1, filter: {
          id_beni: {
            in: listOfAssetIds
          }}});
      let joins = joinsData.data;
      let listOfIdDirectusFiles = "";
      for (let join in joins) {
        listOfIdDirectusFiles += joins[join].id_directus_files + ",";
      }

      const filesData = await this.$client.getFiles({limit: -1, filter: {
          id: {
            in: listOfIdDirectusFiles
          }}});
      let files = filesData.data;

      for (let assetIndex in assets) {
        const asset = assets[assetIndex];

        // Images
        asset.image = null;
        for (let join in joins) {
          if (asset.id === joins[join].id_beni) {
            const imageId = "" + joins[join].id_directus_files;
            for (let file in files) {
              if (files[file].id != imageId)
                continue;
              // Immagini
              let assetUrl = this.$client.getAssetUrl(files[file].private_hash, {key: "directus-large-contain"});
              if (asset.image == null) { // se non è specificato order assegna comunque l'immagine
                asset.image = assetUrl;
              }
            }
          }
        }
      }
      this.shownAssets = assets;
      this.loading = false;
    },
    // Nome della collezione dato l'id
    getCollectionName(idCollection) {
      if (parseInt(idCollection) == 0)
        return "";
      else {
        for (let collection in this.collections)
          if (this.collections[collection].id == idCollection)
            return this.$utilities.getTranslation(this.collections[collection], "nome", this.$i18n.locale);
      }
    },
    getAssetYears(asset) {
      if (asset.anno_inizio == null && asset.anno_fine == null)
        return null;
      let s = "<b>" + this.$t("Periodo") + ": </b>";
      if (asset.anno_inizio == asset.anno_fine)
        return s + asset.anno_inizio;
      return s + asset.anno_inizio + " - " + asset.anno_fine;
    },
    getAssetPlace(asset) {
      let s = this.$utilities.getTranslation(asset, 'catalogo_luogo', this.$i18n.locale);
      if (this.$utilities.isEmpty(s))
        return null;
      s = s.replace("<br />", " - ");
      const el = document.createElement('html');
      el.innerHTML = s;
      s = el.innerText;
      return "<b>" + this.$t("catalogo_luogo") + ": </b>" + s;
    },
    getAssetMaterial(asset) {
      let s = this.$utilities.getTranslation(asset, 'catalogo_materia', this.$i18n.locale);
      if (this.$utilities.isEmpty(s))
        return null;
      s = s.replace("<br />", " - ");
      const el = document.createElement('html');
      el.innerHTML = s;
      s = el.innerText;
      return "<b>" + this.$t("catalogo_materia") + ": </b>" + s;
    },
    getAssetAuthor(asset) {
      let s = this.$utilities.getTranslation(asset, 'catalogo_autore', this.$i18n.locale);
      if (this.$utilities.isEmpty(s))
        return null;
      s = s.replace("<br />", " - ");
      const el = document.createElement('html');
      el.innerHTML = s;
      s = el.innerText;
      return "<b>" + this.$t("catalogo_autore") + ": </b>" + s;
    },
    getAssetBuilder(asset) {
      let s = this.$utilities.getTranslation(asset, 'catalogo_costruttore', this.$i18n.locale);
      if (this.$utilities.isEmpty(s))
        return null;
      s = s.replace("<br />", " - ");
      const el = document.createElement('html');
      el.innerHTML = s;
      s = el.innerText;
      return "<b>" + this.$t("catalogo_costruttore") + ": </b>" + s;
    },
    hoverCard(selectedIndex) {
      this.selectedCard = selectedIndex
    },
    isCardSelected(cardIndex) {
      return this.selectedCard === cardIndex
    },
    hoverCollection(selectedIndex) {
      this.selectedCollection = selectedIndex
    },
    isCollectionSelected(collectionIndex) {
      return this.selectedCollection === collectionIndex
    },
    onPlaceRowSelected(items) {
      if (items[0] != null) {
        this.searchFilter.place = items[0][this.$t("catalogo_luogo")];
        this.$refs.tableMaterials.clearSelected();
        this.$refs.tableAuthors.clearSelected();
        this.searchFilter.material = "";
        this.searchFilter.author = "";
      } else
        this.searchFilter.place = "";
      this.refresh();
    },
    onAuthorRowSelected(items) {
      if (items[0] != null) {
        this.searchFilter.author = items[0][this.$t("nome")];
        this.$refs.tableMaterials.clearSelected();
        this.$refs.tablePlaces.clearSelected();
        this.searchFilter.material = "";
        this.searchFilter.place = "";
      } else
        this.searchFilter.author = "";
      this.refresh();
    },
    onMaterialRowSelected(items) {
      if (items[0] != null) {
        this.searchFilter.material = items[0][this.$t("catalogo_materia")];
        this.$refs.tableAuthors.clearSelected();
        this.$refs.tablePlaces.clearSelected();
        this.searchFilter.author = "";
        this.searchFilter.place = "";
      } else
        this.searchFilter.material = "";
      this.refresh();
    },
  }
}
</script>

<style>
</style>
